export const toTitleCase = (str, full = true) => {
  if (!str || typeof str !== 'string' || str.length === 0) return '';
  return (full ? str.toLowerCase() : str).replace(/^(.)|\s(.)/g, $1 => $1.toUpperCase());
};
